import { useMemo } from 'react';
import { FIELD_SHARING } from '@rsos/capstone/src/constants/capabilities';
import { useBooleanFlagValue } from '@rsos/feature-flags';
import useHasCapability from '@rsos/hooks/useHasCapability';

const useHasAccessToFieldSharing = (): boolean => {
  const uniteSharingFlag = useBooleanFlagValue('unite_sharing', false);
  const hasFieldSharingCapability = useHasCapability(FIELD_SHARING);

  return useMemo(
    () =>
      Boolean(uniteSharingFlag) &&
      Boolean(hasFieldSharingCapability?.hasCapability),
    [uniteSharingFlag, hasFieldSharingCapability],
  );
};

export default useHasAccessToFieldSharing;
